exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-position {\n  margin-top: 30px; }\n\n.error-icon {\n  color: #cb6f67;\n  margin: 0 auto; }\n\n.icon-margin {\n  margin-top: 5px; }\n\n.invalid {\n  border-bottom: 1px solid #cb6f67 !important;\n  box-shadow: 0 1px 0 0 #cb6f67 !important; }\n\n::ng-deep div.invalid {\n  color: #cb6f67 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/user-profile/user-profile.component.scss
// module id = ../../../../../src/app/components/user-profile/user-profile.component.scss
// module chunks = main